/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChartDataDto } from './ChartDataDto';
import {
    ChartDataDtoFromJSON,
    ChartDataDtoFromJSONTyped,
    ChartDataDtoToJSON,
    ChartDataDtoToJSONTyped,
} from './ChartDataDto';

/**
 * 
 * @export
 * @interface YearlyMetricsDto
 */
export interface YearlyMetricsDto {
    /**
     * 
     * @type {ChartDataDto}
     * @memberof YearlyMetricsDto
     */
    monthlyRevenue?: ChartDataDto;
    /**
     * 
     * @type {number}
     * @memberof YearlyMetricsDto
     */
    totalRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyMetricsDto
     */
    totalOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyMetricsDto
     */
    revenueGrowth?: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyMetricsDto
     */
    ordersGrowth?: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyMetricsDto
     */
    averageOrderValue?: number;
}

/**
 * Check if a given object implements the YearlyMetricsDto interface.
 */
export function instanceOfYearlyMetricsDto(value: object): value is YearlyMetricsDto {
    return true;
}

export function YearlyMetricsDtoFromJSON(json: any): YearlyMetricsDto {
    return YearlyMetricsDtoFromJSONTyped(json, false);
}

export function YearlyMetricsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyMetricsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'monthlyRevenue': json['monthlyRevenue'] == null ? undefined : ChartDataDtoFromJSON(json['monthlyRevenue']),
        'totalRevenue': json['totalRevenue'] == null ? undefined : json['totalRevenue'],
        'totalOrders': json['totalOrders'] == null ? undefined : json['totalOrders'],
        'revenueGrowth': json['revenueGrowth'] == null ? undefined : json['revenueGrowth'],
        'ordersGrowth': json['ordersGrowth'] == null ? undefined : json['ordersGrowth'],
        'averageOrderValue': json['averageOrderValue'] == null ? undefined : json['averageOrderValue'],
    };
}

export function YearlyMetricsDtoToJSON(json: any): YearlyMetricsDto {
    return YearlyMetricsDtoToJSONTyped(json, false);
}

export function YearlyMetricsDtoToJSONTyped(value?: YearlyMetricsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monthlyRevenue': ChartDataDtoToJSON(value['monthlyRevenue']),
        'totalRevenue': value['totalRevenue'],
        'totalOrders': value['totalOrders'],
        'revenueGrowth': value['revenueGrowth'],
        'ordersGrowth': value['ordersGrowth'],
        'averageOrderValue': value['averageOrderValue'],
    };
}

